import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/Bandeaux/elmnt-carre.png")